import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import {
	RiskBreakdownEntry,
	riskBreakdownKey,
} from '@Types/riskBreakdown.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const riskBreakdownSelector = createSelector(
	parseNamespace,
	state => state.RiskStore.riskBreakdown,
);

// Keyed by config AND asset, so another model's explanation for the same
// asset id can never show here.
export const selectRiskBreakdownEntry = createSelector(
	[
		riskBreakdownSelector,
		(_state: NamespacedStoreState, configId: string) => configId,
		(_state: NamespacedStoreState, _configId: string, assetId: string) =>
			assetId,
	],
	(slice, configId, assetId): RiskBreakdownEntry | undefined =>
		slice?.[riskBreakdownKey(configId, assetId)],
);
